import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-expandable-text',
  template: `
    <div class="expandable-text">
      <span>{{ displayText }}</span>
      <a *ngIf="isTextTruncated" (click)="toggleExpand()" class="expand-link">
        {{ isExpanded ? ' Mostrar menos' : '...' }}
      </a>
    </div>
  `,
  styles: [`
    .expandable-text {
      overflow: hidden;
      max-width: 100%;
    }
    .expand-link {
      color: #007bff;
      cursor: pointer;
      text-decoration: underline;
    }
  `],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ExpandableTextComponent implements OnInit {
    @Input() text: string = '';
    @Input() maxLength: number = 100;
  
    isExpanded: boolean = false;
    isTextTruncated: boolean = false;
    truncatedText: string = '';
  
    ngOnInit() {
      this.truncateText();
    }
  
    truncateText() {
      if (!this.text || typeof this.text !== 'string') {
        this.truncatedText = '';
        this.isTextTruncated = false;
        return;
      }
    
      if (this.text.length <= this.maxLength) {
        this.truncatedText = this.text;
        this.isTextTruncated = false;
      } else {
        let truncated = this.text.substr(0, this.maxLength);
        let lastSpaceIndex = truncated.lastIndexOf(' ');
        if (lastSpaceIndex > 0) {
          truncated = truncated.substr(0, lastSpaceIndex);
        }
        this.truncatedText = truncated;
        this.isTextTruncated = true;
      }
    }
  
    get displayText(): string {
      return this.isExpanded ? this.text : this.truncatedText;
    }
  
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    }
  }